
let jsonwebtoken = require('jsonwebtoken');

const settings = require('/ps_settings/config.json')

const JWTSECRET = settings.JWT_SECRET_AUTH

const jwt_encode = (indata,
                    refreshable = false,
                    expiresIn = "3h") => {

    indata.refreshable = refreshable;

    try {
        const token = jsonwebtoken.sign(indata,
                                        JWTSECRET,
                                        { expiresIn }
                                        )
        return token

    } catch(e) {
        throw {"error": {"errorCode": 401,
                         "errorText": e
                        }
              }
    }
}

const jwt_decode = (token) => {
    try {
        let origData = jsonwebtoken.verify(token, JWTSECRET)
        return origData;
    } catch(e) {
        throw {"error": {"errorCode": 401,
                         "errorText": e
                        }
              }
    }
}

module.exports = {
    jwt_encode,
    jwt_decode
}

